export default __webpack_public_path__ + "static/media/ChristopherLightsey2015.a5098f3c.jpg";